import { HTTP_INTERCEPTORS, HttpEvent } from "@angular/common/http";
import { Injectable } from "@angular/core";
import {
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
} from "@angular/common/http";
import { from, lastValueFrom, Observable } from "rxjs";

@Injectable()
export class ImpersonatorInterceptor implements HttpInterceptor {
  intercept(
    req: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    return from(this.interceptHelper(req, next));
  }

  private async interceptHelper(
    req: HttpRequest<unknown>,
    next: HttpHandler
  ): Promise<HttpEvent<unknown>> {
    const headersConfig: Record<string, string> = {};

    if (localStorage.hasOwnProperty("impersonator")) {
      headersConfig["Impersonator"] =
        localStorage.getItem("impersonator") ?? "";
    }

    const request = req.clone({ setHeaders: headersConfig });
    return await lastValueFrom(next.handle(request));
  }
}

export const impersonatorInterceptorProviders = [
  {
    provide: HTTP_INTERCEPTORS,
    useClass: ImpersonatorInterceptor,
    multi: true,
  },
];
